<template>
  <v-dialog
    id="fullscreenDialog"
    fullscreen
    v-model="$store.getters.approvalMode"
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
    :close-delay="500"
    :small="$vuetify.breakpoint.smAndDown"
  >
    <div class="contentWrapper">

      <v-toolbar dark color="#041E42">
        <h1
          :class="{'ml-15 headingDesktop': $vuetify.breakpoint.smAndUp, 'ml-1 headingMobile': $vuetify.breakpoint.xsOnly}">
          {{ title }}
        </h1>
      </v-toolbar>

      <v-row justify="center"
             :class="{'mt-10 py-10 mx-3': $vuetify.breakpoint.mdAndUp, 'mt-7 px-3': $vuetify.breakpoint.smOnly, 'mt-0 px-0': $vuetify.breakpoint.xsOnly}">
        <v-col cols="12" lg="8" md="10" sm="11" class="pt-0" v-if="!approved && !rejected && !error">
          <div>
            <v-card
              :class="{'elevation-2 px-10 pb-10 pt-14 mb-8': $vuetify.breakpoint.smAndUp, 'elevation-0 rounded-0 py-10 px-0 mb-0': $vuetify.breakpoint.xsOnly}">
              <NotificationReview
                title="Notification"
                isApproval
              />
              <v-row justify="center">
                <v-col cols="11"
                       :class="{'py-10 px-0': $vuetify.breakpoint.smAndUp, 'py-6 px-2': $vuetify.breakpoint.xsOnly}">
                  <v-textarea
                    v-model="rejectionReason"
                    label="Rejection reason (optional)"
                    placeholder=""
                    outlined
                    hide-details
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-card>
            <v-row :class="{'pt-8 px-3 pb-6': $vuetify.breakpoint.xsOnly}">
              <v-col lg="12"
                     :class="{'pt-0 d-flex justify-end': $vuetify.breakpoint.smAndUp, 'pt-0 d-flex flex-column-reverse': $vuetify.breakpoint.xsOnly}">
                <AdsButton
                  :loading="loadingReject"
                  button-text="Reject"
                  icon="not_interested"
                  :class="{'mr-6': $vuetify.breakpoint.smAndUp, 'mt-3': $vuetify.breakpoint.xsOnly}"
                  color="#B81237"
                  dark
                  @click="submit('rejected')"
                />
                <AdsButton
                  :loading="loadingApprove"
                  icon="assignment_turned_in"
                  button-text="Approve"
                  color="#00A908"
                  dark
                  @click="submit('approved')"
                />
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12" lg="7" md="7" sm="11" :class="{'ma-0': $vuetify.breakpoint.smAndUp, 'mt-10': $vuetify.breakpoint.xsOnly}" v-if="approved || rejected || error">
          <v-card min-height="390" class="pa-12 d-flex flex-column align-center" :class="{'mx-3': $vuetify.breakpoint.xsOnly}">
            <FeatureIcon
              size="160"
              :color="error ? '#041E42' : 'white'"
              :background-color="error ? '#C8DCF0' : rejected ? '#B81237' : '#00A908'"
              :icon="error ? 'error_outline' : rejected ? 'not_interested' : 'assignment_turned_in'"
            />
            <div v-if="rejected || approved">
              <h2 class="mt-6 mb-6" style="color: #041E42; text-align: center;">Notification request {{
                  rejected ? 'rejected' : 'approved'
                }}</h2>
              <div class="d-flex flex-column align-start">
                <p class="mb-0">No further action needed.</p>
                <p>The requester will be notified.</p>
              </div>
            </div>
            <div v-if="error">
              <h2 class="mt-6 mb-6" style="color: #041E42; text-align: center">{{ errorHeading }}
              </h2>
              <div class="d-flex flex-column align-start">
                <div v-html="errorResponse"></div>
                <p class="mb-0">You can either
                  <a @click="handleReload" @keydown.enter="handleReload" class="hyperlinkAds">
                    retry</a>, or
                  <a href="mailto:edpush@det.nsw.edu.au" class="hyperlinkAds">
                    contact support</a>.
                </p>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
import NotificationReview from "@/components/NotificationReview";
import {AdsButton, FeatureIcon} from '@nswdoe/doe-ui-core';

export default {
  name: 'NotificationApproval',
  components: {
    NotificationReview,
    AdsButton,
    FeatureIcon
  },
  data() {
    return {
      title: "",
      rejectionReason: null,
      approved: false,
      rejected: false,
      error: false,
      loadingApprove: false,
      loadingReject: false,
      errorHeading: "",
      errorMessage: "",
      errorResponse: ""
    }
  },
  methods: {
    handleReload() {
      let query = Object.assign({}, this.$route.query);
      delete query.status;
      this.$router.replace({query}).catch(() => {
      });
      this.$router.go(this.$router.currentRoute);
    },
    closeDetailsMode() {
      this.$store.commit('setApprovalMode', false);
      this.$router.push("/notifications");
      this.$store.commit('setNotification', null);
      this.$store.commit('setNotificationSetupDetails', null);
      this.$store.commit('setNotificationMessageDetails', null);
      this.$store.commit('setNotificationAudienceAndScheduling', null);
    },
    submit(response) {
      if (response === 'approved') {
        this.loadingApprove = true;
        this.$store.dispatch('approveNotification')
          .then(() => {
            let query = Object.assign({}, this.$route.query);
            query.status = 'approved';
            this.$router.replace({query}).catch(() => {
            });
            this.approved = true;
          })
          .catch((err) => {
            let query = Object.assign({}, this.$route.query);
            query.status = 'error';
            this.$router.replace({query}).catch(() => {
            });
            this.error = true;
            this.errorHeading = "Failed to approve notification";
            if (err.response && err.response.data.errMsg) {
              this.errorResponse = `<p>${err}</p>
                   <p>Description: ${err.response.data.errMsg}</p>`
            } else {
              this.errorResponse = `<p>${err}.</p>`
            }
          })
        .finally(() => {
          this.loadingApprove = false;
        })
      }
      if (response === 'rejected') {
        this.loadingReject = true;
        this.$store.dispatch('rejectNotification', this.rejectionReason)
          .then(() => {
            let query = Object.assign({}, this.$route.query);
            query.status = 'rejected';
            this.$router.replace({query}).catch(() => {
            });
            this.rejected = true;
          })
          .catch((err) => {
            let query = Object.assign({}, this.$route.query);
            query.status = 'error';
            this.$router.replace({query}).catch(() => {
            });
            this.error = true;
            this.errorHeading = "Failed to reject notification";
            if (err.response && err.response.data.errMsg) {
              this.errorResponse = `<p>${err}</p>
                   <p>Description: ${err.response.data.errMsg}</p>`
            } else {
              this.errorResponse = `<p>${err}.</p>`
            }
          })
        .finally(() => {
          this.loadingReject = false;
        })
      }
    }
  },
  created() {
    if (this.$store.getters.currentNotification) {
      this.title = this.$store.getters.currentNotification.name;
    }
    this.$store.commit('setApprovalMode', true);
  }
}
</script>

<style scoped>
.contentWrapper {
  background-color: #F4F4F7;
  min-height: 100%;
  overflow-x: clip;
}

.close--button {
  position: absolute;
}

.close--button:focus {
  border: 2px solid #ffffff !important;
  border-radius: 50% !important;
  outline: none !important;
}

.headingDesktop {
  font-size: 20px;
  width: 100%;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.headingMobile {
  font-size: 16px;
  width: 100%;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

::v-deep .v-input__slot > .v-text-field__slot > label {
  font-size: 18px !important;
}

.hyperlinkAds {
  color: #1d428a !important;
  text-decoration: underline;
  font-weight: bold;
}
</style>
